import React from 'react'
import './style.css'
import VideoPausedIcon from '../../../assets/icons/video-paused.svg'
import VideoPlayingIcon from '../../../assets/icons/video-playing.svg'
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { updateIsVideoPlaying, updateSeekToDuration } from '../../../redux/slices/userActivity';

export default function VideoController({ playerRef, videoDetails }) {
   const [value, setValue] = useState(0);
   const [duration, setDuration] = useState(0)
   const [videoProgress, setVideoProgress] = useState(0)
   const [values, setValues] = useState([])
   const MAX = 100;
   const { userActivities } = useSelector((state) => state.userActivity);

   const { video, video_url } = useSelector((state) => state.duonutSettings.settings);
   const { videoDuration, isVideoPlaying } = useSelector((state) => state.userActivity);

   const dispatch = useDispatch()

   const getBackgroundSize = () => ({ backgroundSize: `${(value * 100) / MAX}% 100%` })

   // useEffect(() => {
   //    if (playerRef.current) {
   //       // console.log(playerRef.current);
   //       // console.log(playerRef.current.player.progress());
   //       // console.log(playerRef.current.player.progress());
   //       // console.log(playerRef?.current?.getCurrentTime());
   //    }
   // }, [playerRef.current])

   // console.log('videoDetails', videoDetails);

   useEffect(() => {
      setValue(videoDetails.progress * 100 / duration)
   }, [videoDetails.progress])

   useEffect(() => {
      if (videoDuration < 1) return
      setDuration(videoDuration)
   }, [videoDuration])

   useEffect(() => {
      if (!userActivities) return
      let arr = []
      userActivities?.forEach(item => {
         if (item?.question_id?.timestamp === -1) {
            arr.push(videoDuration)
         } else {
            arr.push(item?.question_id?.timestamp)
         }
      })
      setValues(arr)
      // console.log('arr', arr);
      // console.log(userActivities);
   }, [userActivities])
   // useEffect(() => {
   //    if(videoProgress === 0 )return
   //    setValue(videoProgress * videoDuration / 100)
   // }, [videoProgress])

   // useEffect(() => {
   //    dispatch(updateSeekToDuration({ seekToDuration: parseInt(value) }))
   // }, [value])

   useEffect(() => {
      // console.log(playerRef.current?.currentTime)
      // console.log(duration * playerRef.current?.currentTime / 100)
      // console.log(playerRef.current?.currentTime * 100/duration)
      // setTimeout(() => {

      // setValue(playerRef.current?.currentTime * 100 / duration)
      setValue(videoDetails.progress * 100 / duration)

      // }, 1000);
   }, [playerRef.current?.currentTime, duration])

   // console.log(playerRef.current.currentTime);
   const toggleVideoPlaying = () => {
      if (video_url === null) {
         if (isVideoPlaying) {
            // playerRef.current?.pause()
         } else {
            // playerRef.current?.play()
         }
         // return
      }
      dispatch(updateIsVideoPlaying({ isVideoPlaying: !isVideoPlaying }))
   }

   const handleProgressbarChange = e => {
      setValue(e.target.value);
      // console.log(e.target.value * 100 / duration)
      // playerRef.current.currentTime = duration * e.target.value / 100
      const seekAmt = duration * e.target.value / 100
      console.log('seekAmt', seekAmt);
      playerRef.current.seekTo(seekAmt, 'seconds')
      // seekTo()
      // console.log(duration * e.target.value / 100)

   }
   // console.log('duration', duration);
   // console.log('videoDetails', videoDetails);
   // console.log('videoProgress', videoProgress);
   const totalMinutes = Math.floor(duration / 60);
   const totalSeconds = Math.floor(duration % 60);


   let minutes = Math.floor(videoDetails.progress / 60);
   let seconds = Math.floor(videoDetails.progress % 60);

   if (isNaN(minutes)) {
      minutes = 0
   }
   if (isNaN(seconds)) {
      seconds = 0
   }

   // console.log('video_url', video_url);
   // console.log('value', value);

   return (
      <div className='video-controller flex items-center'>
         <div className='play-img-container' onClick={toggleVideoPlaying}>
            <img src={isVideoPlaying ? VideoPlayingIcon : VideoPausedIcon} style={{ width: '40px' }} />
         </div>
         <div className='flex video-time'>
            <p>
               {minutes < 10 ? `0${minutes}` : minutes}
               :
               {seconds < 10 ? `0${seconds}` : seconds}
            </p>
            {' '}
            /
            {' '}
            <p>
               {totalMinutes < 10 ? `0${totalMinutes}` : totalMinutes}
               :
               {totalSeconds < 10 ? `0${totalSeconds}` : totalSeconds}
            </p>
         </div>
         <div className='control-bar-container'>
            <div className='control-bar'>
               <input type='range' className='controller'
                  onChange={(e) => handleProgressbarChange(e)}
                  style={getBackgroundSize()}
                  value={value}
                  min="0"
                  max={MAX}
               />
               {
                  values.map(item => {
                     let left = item * 100 / videoDuration
                     if (left > 100) {
                        left = 100
                     }
                     if (left < 0) {
                        left = 0
                     }
                     return (
                        <div className='controlbar-activity-line' style={{ left: `${left}%` }} >

                        </div>
                     )
                  })
               }
            </div>
         </div>

      </div>
   )
}
